const db = [
  {
    label: "ali",
    name: "Ali",
    description: "Now that I'm working with you, I feel like we could win!",
    imageUrl: "ali.jpg",
  },
  {
    label: "gi-hun",
    name: "Gi-Hun",
    description:
      "You don’t trust people because they are trustworthy. You do it because you have nothing else to rely on.",
    imageUrl: "gi-hun.jpg",
  },
  {
    label: "sae-byeok",
    name: "Sae-Byeok",
    description:
      "I don’t trust people. And that’s twice as true for anyone who’d end up in here. Got it?",
    imageUrl: "sae-byeok.jpg",
  },
  {
    label: "ji-yeong",
    name: "Ji-Yeong",
    description: "I'll make sure you win. Whatever it takes.",
    imageUrl: "ji-yeong.jpg",
  },
  {
    label: "jun-ho",
    name: "Jun-Ho",
    description: "I'm a police officer, remember? I'll find him.",
    imageUrl: "jun-ho.jpg",
  },
  {
    label: "mi-nyeo",
    name: "Mi-Nyeo",
    description: "I’m good at everything except the things that I can’t do.",
    imageUrl: "mi-nyeo.jpg",
  },
  {
    label: "sang-woo",
    name: "Sang-Woo",
    description: "I'm alive right now because I tried damn hard to stay alive.",
    imageUrl: "sang-woo.jpg",
  },
  {
    label: "in-ho",
    name: "In-Ho",
    description: "Everyone is equal while they play this game",
    imageUrl: "in-ho.jpg",
  },
  {
    label: "deok-su",
    name: "Deok-Su",
    description: "We're in Hell here. There's no rules in Hell.",
    imageUrl: "deok-su.jpg",
  },
  {
    label: "il-nam",
    name: "Il-Nam",
    description:
      "Do you know what someone with no money has in common with someone with too much money? Living is no fun for them.",
    imageUrl: "il-nam.jpg",
  },
  {
    label: "gong-yoo",
    name: "Salesman",
    description: "Sir, Would you like to play ddak-ji with me?",
    imageUrl: "gong-yoo.jpg",
  },
  {
    label: "mugunghwadoll",
    name: "Mugunghwa Doll",
    description: "무궁화꽃이 피었습니다🎵. Red Light, Green Light",
    imageUrl: "mugunghwadoll.jpg",
  },
];

let squidgameDictionary = {};
for (let i = 0; i < db.length; i++) {
  squidgameDictionary[db[i].label] = db[i];
}

export default squidgameDictionary;
